module.exports = __webpack_public_path__ + "assets/img/car07.afe3aed3.jpg";